import React, { useEffect, useState } from 'react'

import Button from '@react/react-spectrum/Button'
import Delete from '@react/react-spectrum/Icon/Delete'
import { Table, TBody, TD, TH, THead, TR } from '@react/react-spectrum/Table'
import Textfield from '@react/react-spectrum/Textfield'

export function ArchitectureEditor({ fields, disabled, onChange }) {
  const [rows, setRows] = useState([])
  const hasEmptyRow = rows.length > 0 && rows.filter(r => !r.value).length > 0

  const saveField = (index, propName) => value => {
    const newRows = rows.map((r, idx) => (idx === index ? { ...r, [propName]: value } : r))
    setRows(newRows)
    onChange(newRows)
  }

  const addRow = () => {
    if (!hasEmptyRow) {
      const newRows = [...rows, {}]
      setRows(newRows)
    }
  }

  const deleteRow = index => {
    const newRows = rows.filter((r, idx) => idx !== index)
    setRows(newRows)
    onChange(newRows)
  }

  useEffect(() => {
    setRows(fields)
  }, [fields])

  return (
    <div className='ArchitectureEditor'>
      <Table onSubmit={evt => evt.preventDefault()}>
        <THead>
          <TH width='200xp'>Category</TH>
          <TH width='300px'>Label</TH>
          <TH>Link</TH>
          <TH width='60px'></TH>
        </THead>
        <TBody>
          {rows.map((field, idx) => (
            <TR key={'field-' + idx}>
              <TD>
                <Textfield value={field.category || ''} onChange={saveField(idx, 'category')} disabled={disabled} />
              </TD>
              <TD>
                <Textfield value={field.label || ''} onChange={saveField(idx, 'label')} disabled={disabled} />
              </TD>{' '}
              <TD>
                <Textfield value={field.value || ''} onChange={saveField(idx, 'value')} disabled={disabled} />
              </TD>
              <TD width='60px'>
                <Button
                  variant='tool'
                  aria-label='Delete'
                  icon={<Delete />}
                  onClick={() => deleteRow(idx)}
                  disabled={disabled}
                />
              </TD>
            </TR>
          ))}
          <TR onClick={addRow}>
            <TD>
              <Button variant='action' quiet label='+ Add' disabled={disabled || hasEmptyRow} />
            </TD>
            <TD />
            <TD />
            <TD />
          </TR>
        </TBody>
      </Table>
    </div>
  )
}
